"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDefaultAlias = function getDefaultAlias(name) {
  if (!name) return '';
  return name.toLowerCase().replace(/[^a-z0-9]+/g, '');
};

var _default = getDefaultAlias;
exports.default = _default;